<ng-container *ngIf="navigationItems && initialized">

    <div class="mt-5">

        @if (activeNavigationItem?.action == 'config.detail') {
            <mvs-widget [widgetData]="configDetailWidgetData"></mvs-widget>
        }

        @if (activeNavigationItem?.action == 'config.document.types') {
            <bm-camt-import-config-document-types
                    [configId]="objectIdentifier.objectId"
            ></bm-camt-import-config-document-types>
        }
    </div>

</ng-container>
